import type { TaxInvoiceTranslations } from './types';
import { formatCurrency as formatCurrencyUtil } from '@/utils/currency';
import { useTaxRate, useStoreCurrency } from '@/contexts/StorePricingContext';
import type { Currency } from '@/types';

interface TaxDetailsSectionProps {
  beforeTax: number;
  taxAmount: number;
  total: number;
  t: TaxInvoiceTranslations;
  /**
   * #285 stale 방지: 주문 시점 세율(비율)·통화 스냅샷.
   * 제공 시 우선 사용, 없으면 StorePricingContext 폴백.
   */
  taxRate?: number;
  currency?: string;
}

export function TaxDetailsSection({
  beforeTax,
  taxAmount,
  total,
  t,
  taxRate: orderTaxRate,
  currency: orderCurrency,
}: TaxDetailsSectionProps) {
  const { taxRatePercent: contextPercent } = useTaxRate();
  const { currency: contextCurrency } = useStoreCurrency();
  const taxRatePercent =
    orderTaxRate !== undefined ? Math.round(orderTaxRate * 100) : contextPercent;
  const currency = (orderCurrency ?? contextCurrency) as Currency;
  return (
    <div>
      <h3 className="font-medium text-gray-900 mb-3">{t.invoiceDetails}</h3>
      <div className="bg-gray-50 rounded-lg p-4 space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">{t.beforeTax}</span>
          <span>{formatCurrencyUtil(beforeTax, currency)}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">{t.taxRate}</span>
          <span>{taxRatePercent}%</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">{t.taxAmount}</span>
          <span>{formatCurrencyUtil(taxAmount, currency)}</span>
        </div>
        <div className="border-t pt-2">
          <div className="flex justify-between font-semibold">
            <span>{t.totalAmount}</span>
            <span className="text-blue-600">{formatCurrencyUtil(total, currency)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
